import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Modal from './shared/Modal';
import FeedbackModal from './FeedbackModal';
import JobAppliedSuccessModal from './JobAppliedSuccessModal';
import { Link,useNavigate } from 'react-router-dom';
import sample_company from '../Assets/icons/sample_company.jpg';

const JobSearchCard = ({ isOpenFeedbackModal, setIsOpenFeedbackModal, job, isJobAppliedSuccessfull, setIsJobAppliedSuccessfull }) => {

  const [allwishlist, setWishlist] = useState([]);
  const [AppliedJobs, setAppliedJobs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob_id, setSelectedJob_id] = useState(null);
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const userType = localStorage.getItem("usertype");
  const AddToWishlist = async (job_id) => {
    if (!userid) {
      navigate("/login");
      return;
    }
    const updateWishlist = { userid: userid, job_id: job_id, isactive: 1 };
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}job_wishlist/createjobwishlist`, updateWishlist);
      getAllWishlist();
    } catch (error) {
      console.error(error);
    }
  }

  const getAllWishlist = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}job_wishlist/getwishlistbyuserid/${userid}`)
      setWishlist(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedJob_id(null);
  };

  const HandleOpenModal = (job_id) => {
    if (!userid) {
      window.location.href = "/login";
      return;
    }
    setSelectedJob_id(job_id);
    setIsModalOpen(true);
  }

  const HandleApplyJob = () => {
    addApplication(selectedJob_id);
    closeModal();
  }

  const handleDeclineJob = () => {
    closeModal();
  }

  const getAppliedJobs = async () => {
     try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}job_application/byuserid/${userid}`);
      // console.log(response.data);
      setAppliedJobs(response.data);
    } catch (error) {
      console.error(error);
    }
  }
  const addApplication = async (job_id) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}job_application/createapplication/${job_id}/${userid}`);
      setAppliedJobs((prev) => [...prev, { job_id }]);
      setIsJobAppliedSuccessfull(true);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
  if (userid) {
    getAllWishlist();
    getAppliedJobs();
  }
  }, [selectedJob_id])

  return (
    <>
      <Modal
        id={selectedJob_id}
        onConfirm={HandleApplyJob}
        onDecline={handleDeclineJob}
        onClose={closeModal}
        show={isModalOpen}
      />
      <FeedbackModal isOpenFeedbackModal={isOpenFeedbackModal} setIsOpenFeedbackModal={setIsOpenFeedbackModal} />
      <JobAppliedSuccessModal isOpen={isJobAppliedSuccessfull} setIsOpen={setIsJobAppliedSuccessfull} setIsOpenFeedbackModal={setIsOpenFeedbackModal} />

      <div className="col-lg-6 d-flex">
      <div className="job-item d-flex flex-column w-100">
        <div className="job-search-item cursor-pointer"
          onClick={() => navigate(`/job-details/${job.job_id}`)}
        >
          {allwishlist.some((item) => item.job_id === job.job_id) && userid ? (
            <p className="job-bookmark">
              <i className="fas fa-check text-success fs-4"/>
            </p>
          ) : (
            <p className="job-bookmark cursor-pointer">
              <i className="fe-bookmark" onClick={(e) => { e.stopPropagation(); AddToWishlist(job.job_id); }} />
            </p>
          )}
          <div className="job-top">
            <div className="job-img">
              <img 
              loading="lazy"
              role="presentation"
              decoding="async"
              fetchpriority="high"src={job.image || sample_company} alt="Default Company Logo" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">{job.job_name}</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> {job.company_name}
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> {job.experience}
              </li>
              <li>
                <i className="fe-check-circle" /> {job.package ? job.package : "Not Available"}
              </li>
              {/* <li>
                <i className="fe-clock" /> {new Date(job.post_date).toLocaleDateString()}
              </li> */}
              <li>
                <i className="fe-map-pin" /> {job.city}
              </li>
            </ul>
              <div className="job-skill">
                {job.skills ? (() => {
                  let skillsArray = [];
                  if (typeof job.skills === "string") {
                    try {
                      const parsed = JSON.parse(job.skills);
                      skillsArray = Array.isArray(parsed) ? parsed : [];
                    } catch (err) {
                      console.error("Invalid JSON in job.skills:", err);
                      return <p>Invalid skill data</p>;
                    }
                  } else if (Array.isArray(job.skills)) {
                    skillsArray = job.skills;
                  }

                  return skillsArray.length > 0 ? (
                    skillsArray.map((skill, index) => (
                      <Link to="#" className="m-1 badge badge-secondary" key={index}>
                        {skill.skill_name}
                      </Link>
                    ))
                  ) : (
                    <p>No skills available</p>
                  );
                })() : (
                  <p>No skills available</p>
                )}
              </div>

          </div>
          </div>
          <div className="mt-auto job-bottom">
            {/* <div className="job-salary">
              <span className="job-salary-amount">{job.package || "Not Available"}</span>
              {job.package && " LPA "}
            </div> */}
            <Link className="theme-btn" to={`/job-details/${job.job_id}`}>
              View Details
            </Link>
          </div>
      </div>
      </div>
    </>
  )
}

export default JobSearchCard;
